<div class="a">
  <h3>{{'Menu.NotAvailable' | translate}}</h3>
  <h4>{{'Menu.ScheduleAvailableDate' | translate}}</h4>
</div>

<ion-label class="center">{{ 'General.Storeaddress' | translate}}</ion-label>
<ion-row > <ion-col> <ion-card-subtitle  class="center">{{storeAddress}}</ion-card-subtitle> </ion-col></ion-row>

<ion-row><ion-col  class="center">
  <ion-select [placeholder]="translationService.translate(menuService.menuDayPlaceholder)" (ionChange)="menuService.preparationDatePickerChanged(orderType, selectedOrderDate)" class="date-picker" [(ngModel)]="selectedOrderDate">
    @for (days of menuService.prepareFollowingDays; track days) {
      <ion-select-option [value]="days.key">{{days.value}}</ion-select-option>
    }
  </ion-select>

  <div style="float:left; margin: 5px;">&#64;</div>
  <ion-select [placeholder]="translationService.translate(menuService.menuTimePlaceholder)" class="date-picker" [(ngModel)]="selectedOrderTime">
    @for (time of menuService.prepareFollowingTime; track time; let i = $index) {
      <ion-select-option [value]="time.key">{{time.value}}</ion-select-option>
    }
  </ion-select>
</ion-col>
</ion-row>

<ion-row>
  <ion-col style="padding: 0">
    <ion-item [disabled]="!selectedOrderTime" (click)="continueToItemDetail()" class="checkout ion-text-center">

      <ion-label style="color: var(--ion-color-primary-contrast, #fff)">
        {{ 'Menu.AddToOrder' | translate }}
      </ion-label>
      <ion-icon style="color: var(--ion-color-primary-contrast, #fff)" name="chevron-forward-outline" item-right></ion-icon>
    </ion-item>
  </ion-col>
</ion-row>
